<template>
  <b-container class="m-2 mx-4">
    <b-row class="title-section">
      <p class="p-title-section">
        Units
      </p>
    </b-row>
    <TextInputConfiguration
      :controller="NotationTextCtrller"
      :sizeinput="'sm'"
      class="mt-3"
      :forcerow="true"
    />
    <TextInputConfiguration
      :controller="ConcUnitsTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
      class="mb-3"
      :disabled="SwapUnitsCtrller.value"
    />
    <SimpleSliderConfiguration
      ref="sliderSwapUnits"
      :controller="SwapUnitsCtrller"
      checked-label="Alternative Units"
      unchecked-label="Base Units"
      :width="110"
      :height="20"
    />
    <TextInputConfiguration
      :controller="ConvertionFactorTextCtrller"
      :sizeinput="'sm'"
      class="mt-3"
      :forcerow="true"
      :disabled="!SwapUnitsCtrller.value"
    />
    <TextInputConfiguration
      :controller="ConvertionOffsetTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
      :disabled="!SwapUnitsCtrller.value"
    />
    <TextInputConfiguration
      :controller="AlternativeUnitTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
      :disabled="!SwapUnitsCtrller.value"
    />
  </b-container>
</template>

<script>
import {inputTextConfCtrller, genericConfCtrller} from '@/assets/classes/configuration.js'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import SimpleSliderConfiguration from '@/components/properties/elements/SimpleSliderConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapActions } from 'vuex'

const contextHelpRoot='ReportViewer/Units/'

export default {
  name: 'UnitsConfiguration',
  components: { 
    TextInputConfiguration,
    SimpleSliderConfiguration
  },
  data () {
    return {
      elementsConfig: [],
      ConcUnitsTextCtrller: new inputTextConfCtrller(ConfigName.fitLabel,'Unit','','mM',()=>{return true},null,contextHelpRoot+'Concentration',false,true),
      NotationTextCtrller: new inputTextConfCtrller(ConfigName.notationFit,'Notation','','Concentration',()=>{return true},null,contextHelpRoot+'Notation',false,true),
      SwapUnitsCtrller: new genericConfCtrller('SWAP_UNIT', false, contextHelpRoot+'Swap', true),
      ConvertionFactorTextCtrller: new inputTextConfCtrller('CONV_FACT_UNIT','Conversion Factor','','1000',()=>{return true},null,contextHelpRoot+'ConvertionFactor',true,true),
      ConvertionOffsetTextCtrller: new inputTextConfCtrller('CONV_OFFS_UNIT','Conversion Offset','','0',()=>{return true},null,contextHelpRoot+'ConvertionOffset',true,true),
      AlternativeUnitTextCtrller: new inputTextConfCtrller('ALT_UNIT','Alternative Unit','','M',()=>{return true},null,contextHelpRoot+'AlternativeUnit',false,true),
    }
  },
  mounted(){
    this.elementsConfig=[
      this.ConcUnitsTextCtrller,
      this.NotationTextCtrller,
      this.SwapUnitsCtrller,
      this.ConvertionFactorTextCtrller,
      this.ConvertionOffsetTextCtrller,
      this.AlternativeUnitTextCtrller,
    ]
    this.elementsConfig.forEach(conf=>conf.setParent(this))
    this.$refs.sliderSwapUnits.forceRerender() //Trick required on the slider, because it doesn't render correctly after updating the value
    this.$watch(
      'ConcUnitsTextCtrller.value',
      (new_value) => {
        this.setUnitsReportViewer(new_value)
      }
    );
    this.$watch(
      'NotationTextCtrller.value',
      (new_value) => {
        this.setNotationReportViewer(new_value)
      }
    );
  },
  methods:mapActions([
    'setContextOnHover',
    'setConfigReportModifiedReportViewer',
    'setUnitsReportViewer',
    'setNotationReportViewer',
  ]),
}
</script>

<style lang="scss" scoped>
.label{
  margin:0px;
  font-size: 0.8rem;
}

.header{
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}
::v-deep .label-input-text{
  font-size: 0.8rem;
}
</style>
